import axios from 'axios';
import AuthService from './auth.service';

const request = axios.create({
  baseURL: '/api',
});

function gatherToken(state = 'main') {
  const user = JSON.parse(localStorage.getItem('_auth'));
  const actions = { main: 'accs_token', refresh: 'rfsh_token' };
  return user ? `Bearer ${user[actions[state]]}` : null;
}


request.interceptors.request.use(
  (config) => {
    const accsToken = gatherToken();
    // eslint-disable-next-line
    config.headers.Authorization = accsToken;
    return config;
  },
  err => Promise.reject(err),
);

async function refreshAccessToken() {
  return AuthService.refresh(gatherToken('refresh'));
}

request.interceptors.response.use(
  resp => resp.data,
  async (err) => {
    const originalReq = err.config;
    // eslint-disable-next-line
    if (err.response.status == 401 && err.response.data.msg == 'THE' && !originalReq._retry) {
      console.log('Your token needs to be updated!');
      // eslint-disable-next-line
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken) {
        originalReq.headers.Authorization = `Bearer ${newAccessToken}`;
        return request(originalReq);
      }
    }
    return Promise.reject(err);
  },
);

export default request;



// WEBPACK FOOTER //
// ./src/services/axios.service.js